export const ebEnv = process.env.REACT_APP_ENVIRONMENT || 'dev';

export function isProd() {
  return ebEnv === 'prod';
}

export function isDev() {
  return ebEnv === 'dev';
}

export const ebChainId = isProd()
  ? 1 // Mainnet
  : isDev()
  ? 4 // Rinkeby
  : parseInt(
      process.env.REACT_APP_EB_NETWORK_ID || process.env.REACT_APP_LOCAL_CHAIN_ID || '12345'
    );

export const futuraChainId = isProd()
  ? 137 // Polygon
  : isDev()
  ? 80001 // Mumbai
  : parseInt(
      process.env.REACT_APP_FUTURA_NETWORK_ID || process.env.REACT_APP_LOCAL_CHAIN_ID || '12345'
    );

export const futuraContractAddress = isProd()
  ? '0xcCc96454683970352a26ff06F4fB9CA83D19e9F7'
  : '0xfc18CB10E4F3A11ecC7C7E08becE13e6eC2cca0C';

export const defaultChainId = futuraChainId;
export const platformChainIds = [ebChainId, futuraChainId];
export const platformCollectionIds = isProd()
  ? {
      genesis: 'f8dcc14a-f8eb-4a0f-87f9-c842de856108',
      enigma: '505184b6-1f69-46f7-be73-c26d7fc2dfb1',
      futura: '0a3c68e7-fb04-432d-a68b-42d782ed8f27',
      mixpass: 'e0921abd-f262-4ce6-a892-891978a992b3',
      wearable: 'f5b24ca0-2e5c-4451-8ea4-900cad6806d2',
    }
  : {
      genesis: 'ccd7372f-8344-4381-9ad8-be5d0dc01c3c',
      enigma: '3a59e9e1-43a4-469f-8c27-2aff32feb366',
      futura: 'f507c1b5-12ce-4dfc-8a8a-0749e261e98f',
      mixpass: '7fb2ef0d-2563-4ed5-8ddd-52cd65794b59',
      wearable: 'ffa7e7c2-addc-4f75-897c-a0241a2535cb',
    };

export const mixpassOpenseaURL = isDev()
  ? 'https://testnets.opensea.io/assets/mumbai/'
  : 'https://opensea.io/assets/matic/';
export const wearablesOpenseaURL = isDev()
  ? 'https://testnets.opensea.io/assets/rinkeby/'
  : 'https://opensea.io/assets/';

export const infuraKey = process.env.REACT_APP_INFURA_KEY;

export const etherscanBaseURL = isProd()
  ? 'https://etherscan.io'
  : isDev()
  ? 'https://rinkeby.etherscan.io'
  : process.env.REACT_APP_ETHERSCAN_BASE_URL;

export const polygonScanBaseURL = isProd()
  ? 'https://polygonscan.com/tx'
  : 'https://mumbai.polygonscan.com/tx';

export const legacyApiBaseUrl =
  process.env.REACT_APP_API_BASE_URL || 'https://staging-api.eulerbeats.com/api';

export const platformPublicApiBaseUrl = isProd()
  ? 'https://public-api.phosphor.xyz'
  : isDev()
  ? 'https://public-api.stg.phosphor.xyz'
  : process.env.REACT_APP_PLATFORM_PUBLIC_API_BASE_URL;

export const organizationId = isDev()
  ? 'd2900b3a-0dad-4242-97e6-8c0c8b48d983'
  : isProd()
  ? '52479a52-3204-4278-841f-7832deebedb7'
  : String(process.env.REACT_APP_ORGANIZATION_ID);

export const bncDappId = process.env.REACT_APP_BNC_DAPP_ID;

export const countdownMode = process.env.REACT_APP_COUNTDOWN_MODE;

export const discordURL = 'https://discord.gg/zmkpBsE4Me';
export const twitterURL = 'https://twitter.com/eulerbeats';
export const contactEmail = 'eulerbeats@consensys.net';
export const openseaSocialLink = 'https://opensea.io/collection/eulerbeats-futura';

export const siteDisabled =
  localStorage.getItem('21575894274') !== null ? false : process.env.REACT_APP_SITE_DISABLED;

export const warningMessages = [
  process.env.REACT_APP_WARNING_MESSAGE_1 || '',
  process.env.REACT_APP_WARNING_MESSAGE_2 || '',
  process.env.REACT_APP_WARNING_MESSAGE_3 || '',
];

export const bpmControlEnabled = true;

export const futuraPlayerBaseUrl = 'https://ebfuturaplayer.z13.web.core.windows.net';

export const openseaApiKey = 'f0f8e4bcf8a0405ba988ceaa0c333bb8';

export const remixEnabled = true;

// WETH on polygon, DERC on mumbai
export const remixPaymentToken = isProd()
  ? '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619'
  : '0xfe4F5145f6e09952a5ba9e956ED0C25e3Fa4c7F1';
